<template>
    <svg
        id="Camada_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 200 200"
        style="enable-background: new 0 0 200 200"
        xml:space="preserve"
    >
        <path
            d="M57.1,129.4h111.5c1.5,0,2.7-1.2,2.7-2.7V40.3c0-1.5-1.2-2.7-2.7-2.7c0,0,0,0,0,0H57.1c-1.5,0-2.7,1.2-2.7,2.7c0,0,0,0,0,0
	v86.4C54.4,128.2,55.6,129.4,57.1,129.4z M59.8,124v-15.2c0.8,0.3,1.7,0.2,2.4-0.3L78.4,98c5.6-3.6,12.7-3.6,18.3,0l5.6,3.6l0,0
	l12.9,8.4c1.3,0.8,3,0.4,3.8-0.9c0.8-1.2,0.4-2.9-0.8-3.7l-9.6-6.2l16.4-11.7c5.9-4.2,13.7-4.2,19.6,0l21.2,15.1
	c0.1,0,0.1,0.1,0.2,0.1V124L59.8,124z M165.9,43v53.1l-18.2-13c-7.8-5.5-18.2-5.5-25.9,0L103.6,96l-4-2.6c-7.4-4.8-16.9-4.8-24.2,0
	l-15.6,10.1V43H165.9z"
        />
        <path
            d="M177.6,28.8H48.1c-1.5,0-2.7,1.2-2.7,2.7v14.3h-4.5V27.3c0-4.3-3.5-7.7-7.7-7.7s-7.7,3.5-7.7,7.7v18.5H23
	c-1.5,0-2.7,1.2-2.7,2.7v15.1c0,1.5,1.2,2.7,2.7,2.7h2.4v34.4H23c-1.5,0-2.7,1.2-2.7,2.7v15.1c0,1.5,1.2,2.7,2.7,2.7h2.4v57.2
	c0,1.5,1.2,2.7,2.7,2.7h10c1.5,0,2.7-1.2,2.7-2.7l0,0v-57.2h4.5v14.3c0,1.5,1.2,2.7,2.7,2.7h129.5c1.5,0,2.7-1.2,2.7-2.7v-104
	C180.4,30,179.1,28.8,177.6,28.8z M45.4,66.3v34.4h-4.5V66.3H45.4z M45.4,60.8H25.7v-9.6h19.6L45.4,60.8z M30.9,27.3
	c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3v18.5h-4.6V27.3z M30.9,66.3h4.6v34.4h-4.6V66.3z M35.5,175.7h-4.6v-54.5h4.6V175.7z
	 M25.7,115.8v-9.6h19.6v9.6H25.7z M174.9,132.8H50.8V34.2h124.1V132.8z"
        />
        <path
            d="M97.6,82.6c7.2,0,13.1-5.8,13.1-13.1s-5.8-13.1-13.1-13.1c-7.2,0-13.1,5.8-13.1,13.1c0,0,0,0,0,0
	C84.5,76.8,90.4,82.6,97.6,82.6z M97.6,62c4.2,0,7.6,3.4,7.6,7.6c0,4.2-3.4,7.6-7.6,7.6c-4.2,0-7.6-3.4-7.6-7.6c0,0,0,0,0,0
	C90,65.4,93.4,62,97.6,62L97.6,62z"
        />
    </svg>
</template>

<script>
    export default {
        name: 'FlagIcon',
    };
</script>
